import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {
  doCreateProductCategory,
  doDeleteProductCategory,
  doListProductCategories,
  doUpdateProductCategory,
} from "../../services/product.service";
import { doCreateCampaign, doCreatePromo, doDeleteCampaign, doDeletePromo, doListCampaigns, doListPromos, doUpdateCampaign, doUpdatePromo } from "../../services/maintenance.service";

export const onGetProductCategoryList = createAsyncThunk("productCategory/getProductCategoryList", async () => {
  try {
    const response: any = await doListProductCategories(0);
    return response.data;
  } catch (error) {
    return error;
  }
})

export const onAddProductCategory = createAsyncThunk("productCategory/addProductCategoryList", async (params: any) => {
  try {
    const data = await doCreateProductCategory(params);
    toast.success("Product Category Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Product Category Added Failed", { autoClose: 2000 });
    return error;
  }
})

export const onUpdateProductCategory = createAsyncThunk("productCategory/updateProductCategoryList", async (params: any) => {
  try {
    const data = await doUpdateProductCategory(params);
    toast.success("Product Category updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Product Category updated Failed", { autoClose: 2000 });
    return error;
  }
})

export const onDeleteProductCategory = createAsyncThunk("productCategory/deleteProductCategoryList", async (productCategoryId: string) => {
  try {
    const data = await doDeleteProductCategory(productCategoryId);
    toast.success("Product Category deleted Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Product Category deleted Failed", { autoClose: 2000 });
    return error;
  }
})

export const onGetCampaignList = createAsyncThunk("campaign/getCampaignList", async () => {
  try {
    const response: any = await doListCampaigns(0)
    return response;
  } catch (error) {
    return error;
  }
})

export const onAddCampaign = createAsyncThunk("campaign/addCampaign", async (params: any) => {
  try {
    const data = await doCreateCampaign(params);
    toast.success("Campaign Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Campaign Added Failed", { autoClose: 2000 });
    return error;
  }
})

export const onUpdateCampaign = createAsyncThunk("campaign/updateCampaign", async (params: any) => {
  try {
    const data = await doUpdateCampaign(params);
    toast.success("Campaign Updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Campaign Updated Failed", { autoClose: 2000 });
    return error;
  }
})

export const onDeleteCampaign = createAsyncThunk("campaign/deleteCampaign", async (campaignId: string) => {
  try {
    const data = await doDeleteCampaign(campaignId);
    toast.success("Campaign Deleted Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Campaign Deleted Failed", { autoClose: 2000 });
    return error;
  }
})

export const onGetPromoList = createAsyncThunk("promo/getPromoList", async () => {
  try {
    const response: any = await doListPromos(0);
    return response;
  } catch (error) {
    return error;
  }
})

export const onAddPromo = createAsyncThunk("promo/addPromo", async (params: any) => {
  try {
    const data = await doCreatePromo(params);
    toast.success("Promo Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Promo Added Failed", { autoClose: 2000 });
    return error;
  }
})

export const onUpdatePromo = createAsyncThunk("promo/updatePromo", async (params: any) => {
  try {
    const data = await doUpdatePromo(params);
    toast.success("Promo Updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Promo Updated Failed", { autoClose: 2000 });
    return error;
  }
})

export const onDeletePromo = createAsyncThunk("promo/deletePromo", async (promoId: string) => {
  try {
    const data = await doDeletePromo(promoId);
    toast.success("Promo Deleted Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Promo Deleted Failed", { autoClose: 2000 });
    return error;
  }
})

